"use strict";

var _objectSpread = require("/opt/atlassian/pipelines/agent/build/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/objectSpread2");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Freeze = void 0;

var jsx_runtime_1 = require("react/jsx-runtime");

var react_1 = require("react");

var Sequence_1 = require("./Sequence");

var timeline_position_state_1 = require("./timeline-position-state");

var Freeze = function Freeze(_ref) {
  var frame = _ref.frame,
      children = _ref.children;

  if (typeof frame === 'undefined') {
    throw new Error("The <Freeze /> component requires a 'frame' prop, but none was passed.");
  }

  if (typeof frame !== 'number') {
    throw new Error("The 'frame' prop of <Freeze /> must be a number, but is of type ".concat(typeof frame));
  }

  if (Number.isNaN(frame)) {
    throw new Error("The 'frame' prop of <Freeze /> must be a real number, but it is NaN.");
  }

  if (!Number.isFinite(frame)) {
    throw new Error("The 'frame' prop of <Freeze /> must be a finite number, but it is ".concat(frame, "."));
  }

  var context = (0, react_1.useContext)(timeline_position_state_1.TimelineContext);
  var value = (0, react_1.useMemo)(function () {
    return _objectSpread(_objectSpread({}, context), {}, {
      playing: false,
      imperativePlaying: {
        current: false
      },
      frame: frame
    });
  }, [context, frame]);
  return (0, jsx_runtime_1.jsx)(timeline_position_state_1.TimelineContext.Provider, {
    value: value,
    children: (0, jsx_runtime_1.jsx)(Sequence_1.SequenceContext.Provider, {
      value: null,
      children: children
    })
  });
};

exports.Freeze = Freeze;